export default [{
	//员工统计
	path: '/EmployeeStatistics',
	name: 'EmployeeStatistics',
	component: (resolve) => require(['@/pages/sysSets/Employee/index.vue'], resolve),
	meta: {
		keepAlive:true,
	},
}, {
	//证书统计
	path: '/CertificateStatistics',
	name: 'CertificateStatistics',
	meta: {
		detail: {
			name: 'personCertificateDetail',
		},
	},
	meta: {
		keepAlive:true,
	},
	component: (resolve) => require(['@/pages/sysSets/Certificate/index.vue'], resolve)
},{
	//预警信息
	path:'/EarlyWarning',
	name:'EarlyWarning',
	meta: {
		keepAlive:true,
	},
	component:(resolve)=>require(['@/pages/EarlywarningAndAnnouncement/EarlyWarning/index.vue'],resolve)
},{
	//招标，公告
	path:'/Announcement',
	name:'Announcement',
	component:(resolve)=>require(['@/pages/EarlywarningAndAnnouncement/Announcement/index.vue'],resolve)
},{
	//系统公告详情页面
	path:'/SystemAnnouncementDetails',
	name:'SystemAnnouncementDetails',
	component:(resolve)=>require(['@/pages/EarlywarningAndAnnouncement/Details/systemDetail.vue'],resolve)
 },
 {
	//分公司管理
	path:'/BranchComManage',
	name:'BranchComManage',
	meta: {
		keepAlive:true,
	},
	component:(resolve)=>require(['@/pages/branchManagement/index.vue'],resolve)
},{
	//分公司新增页面
	path:'/BranchComManageAdded',
	name:'BranchComManageAdded',
	component:(resolve)=>require(['@/pages/branchManagement/BranchComManageEditorsAdded/add.vue'],resolve)
},
{
	//分公司编辑页面
	path:'/BranchComManageEditors',
	name:'BranchComManageEditors',
	component:(resolve)=>require(['@/pages/branchManagement/BranchComManageEditorsAdded/edit.vue'],resolve)
},{
	//公式公告列表页面
	path:'/PublicNoticeInfo',
	name:'PublicNoticeInfo',
	component:(resolve)=>require(['@/pages/formulaBulletin/index.vue'],resolve)
},{
	//考试管理
	path:'/ExaminationManage',
	name:'ExaminationManage',
	meta: {
		keepAlive:true,
	},
	component:(resolve)=>require(['@/pages/certificateManger/test/other_qym/index.vue'],resolve)
},{
	//考试管理编辑
	path: '/ExaminationEdit',
	name: 'ExaminationEdit',
	component: (resolve) => require(['@/pages/certificateManger/test/other_qym/pages/edit.vue'], resolve)
},
{
	//考试管理新增
	path: '/ExaminationAdd',
	name: 'ExaminationAdd',
	component: (resolve) => require(['@/pages/certificateManger/test/other_qym/pages/add.vue'], resolve)
}
,{
	//考试管理查看详情
	path: '/ExaminationDetail',
	name: 'ExaminationDetail',
	component: (resolve) => require(['@/pages/certificateManger/test/other_qym/pages/detail.vue'], resolve)
},{
	//公司公告
	path:'/CompanyInfo',
	name:'CompanyInfo',
	meta: {
		keepAlive:true,
	},
	component:(resolve)=>require(['@/pages/companyInfo/index'],resolve)
},{
	//公司公告详情页面
	path:'/CompanyAnnouncementDetails',
	name:'CompanyAnnouncementDetails',
	component:(resolve)=>require(['@/pages/EarlywarningAndAnnouncement/Details/companyDetail.vue'],resolve)
},{
	//公司公告新增
	path:'/CompanyInfoAdd',
	name:'CompanyInfoAdd',
	component:(resolve)=>require(['@/pages/companyInfo/editAndAdd/add'],resolve)
},{
	//公司公告编辑
	path:'/CompanyInfoEdit',
	name:'CompanyInfoEdit',
	component:(resolve)=>require(['@/pages/companyInfo/editAndAdd/edit'],resolve)
},
{//企业基本信息
	path:'/CompanyBasicInfo',
	name:'CompanyBasicInfo',
	component:(resolve)=>require(['@/pages/branchManagement/companyBasicInformation/index'],resolve)
}
]


// WEBPACK FOOTER //
// ./src/router/map/qym.js